export default __webpack_public_path__ + "static/media/sidebar-0.172b0cea.jpg";